/**
 * Re-opening the CookieYes consent banner.
 *
 * GDPR requires withdrawing consent to be as easy as giving it, so every page
 * needs a way back to the banner after the first choice has been made. CookieYes
 * exposes `window.revisitCkyConsent()` for that, but it only exists once the CDN
 * script in public/index.html has loaded - and never if an ad blocker strips it.
 * The floating revisit tab it renders is the documented fallback, so click that
 * when the function is missing.
 */
export function reopenCookieSettings(): boolean {
  if (typeof window.revisitCkyConsent === "function") {
    window.revisitCkyConsent();
    return true;
  }

  const revisitTab = document.querySelector<HTMLElement>(
    ".cky-btn-revisit-wrapper, .cky-revisit-bottom-left, .cky-revisit-bottom-right"
  );
  if (revisitTab) {
    revisitTab.click();
    return true;
  }

  return false;
}
